import { render } from "./NumberSpinner.vue?vue&type=template&id=6fb2beb2&ts=true"
import script from "./NumberSpinner.vue?vue&type=script&lang=ts"
export * from "./NumberSpinner.vue?vue&type=script&lang=ts"

import "./NumberSpinner.vue?vue&type=style&index=0&id=6fb2beb2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__